// What can be in a project scope, and where the assets are listed and opened (US 9396)
export const SCOPE_KINDS = {
  process: {
    modelType: 'App\\Process\\Models\\Process',
    endpoint: 'processes/small',
    route: 'processes.view',
    icon: 'cube',
    label: 'projects.launcher.scopes.process'
  },
  activity: {
    modelType: 'App\\Activity\\Models\\Activity',
    endpoint: 'activities/small',
    route: 'activities.view',
    icon: 'project-diagram',
    label: 'projects.launcher.scopes.activity'
  },
  system: {
    modelType: 'App\\System\\Models\\System',
    endpoint: 'systems',
    params: {without_parent: 1},
    route: 'systems.view',
    icon: 'desktop',
    label: 'projects.launcher.scopes.system'
  },
  third_party: {
    modelType: 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty',
    endpoint: 'third-parties',
    route: 'contracts.view',
    icon: 'exchange-alt',
    label: 'projects.launcher.scopes.third_party'
  },
  policy: {
    modelType: 'App\\Maintenance\\Policy\\Models\\Policy',
    endpoint: 'policies',
    params: {without_parent: 1},
    route: 'policies.view',
    icon: 'file-invoice',
    label: 'projects.launcher.scopes.policy'
  },
  control: {
    modelType: 'App\\GenericControl\\Models\\GenericControl',
    endpoint: 'generic-controls',
    // Controls are offered for the project's type and scope, like before
    params: function(project) {
      return {type: project.type, scopes: project.scope ? [project.scope] : undefined};
    },
    route: 'generic_controls.view',
    icon: 'shield-alt',
    label: 'projects.scope_tab.controls'
  }
};

export function scopeKind(kind) {
  return SCOPE_KINDS[kind];
}

// Extra list parameters of a kind for a project
export function kindParams(kind, project) {
  let params = SCOPE_KINDS[kind].params;
  return typeof params === 'function' ? params(project) : (params || {});
}

// Users of an asset with the owner flag; owners or members only
export function assetUsers(users, owner) {
  return _.filter(users || [], function(user) {
    return owner ? !!user.owner : !user.owner;
  });
}
